import React from "react";
import { Users } from "../fasades/users";
import { IoClose } from "react-icons/io5";
import { RoundButton } from "../chatbot/components/roundbutton";
import './pay.css';
import { DialogManager } from "../fasades/dialogmanager";

type PayCheckoutState = {
    amount: number;
    displayAmount: string;
    errors: {
      amount?: string;
    };
}

type Props = {};

export class PayCheckoutDialog extends React.Component<Props, PayCheckoutState> {

    dialogRef = React.createRef<HTMLDialogElement>();

    constructor(props: any) {
        super(props);

        this.state = {
            amount: 5000,
            displayAmount: "50.00",
            errors: {}
        };

        this.handlePay = this.handlePay.bind(this);
        this.handleAmountChange = this.handleAmountChange.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    static async showDialog(): Promise<void> {
        return new Promise(() => {
            DialogManager.open(<PayCheckoutDialog/>);
        });
    }

    componentDidMount(): void {
        if (this.dialogRef.current) {
            this.dialogRef.current.showModal();
        }
    }

    handleClose() {
        if (this.dialogRef.current) {
            this.dialogRef.current.close();
        }
        DialogManager.close();
    }

    handleAmountChange(value: string) {
        value = value.trim();

        if (/[a-zA-Z]/.test(value)) {
            this.setState((prevState: PayCheckoutState) => ({ 
                errors: { ...prevState.errors, amount: "Amount cannot contain letters" }
            }));
            return;
        }

        const regex = /^\d+(\.\d{0,2})?$/;
        if (!regex.test(value)) {
            this.setState((prevState: PayCheckoutState) => ({ 
                errors: { ...prevState.errors, amount: "Invalid amount format" }
            }));
            return;
        }

        let [dollars, cents = ""] = value.split(".");
        cents = cents.padEnd(2, "0");
        const amountInCents = parseInt(dollars, 10) * 100 + parseInt(cents, 10);

        this.setState((prevState: PayCheckoutState) => ({ 
            amount: amountInCents,
            errors: { ...prevState.errors, amount: undefined }
        }));
    }

    validateAll(): boolean {
        const { displayAmount } = this.state;
        const errors: PayCheckoutState['errors'] = {};
        
        if (!displayAmount.trim()) {
            errors.amount = "Amount is required";
        } else if (+(this.state.displayAmount) < 0.5) {
            errors.amount = "Amount must be greater than 0.5";
        }

        this.setState({ errors });
        return Object.keys(errors).length === 0;
    }

    handlePay(event: React.FormEvent) {
        event.preventDefault();
        if (!this.validateAll()) {
            return;
        }

        Users.getCheckout(this.state.amount);
    };

    handleChange(event: React.ChangeEvent<HTMLInputElement>) {
        const { value } = event.target;
        this.setState({displayAmount: value});
        this.handleAmountChange(value);
    }

    render() {
        return (
        <dialog ref={this.dialogRef} className="dialogStyle">
            <div className="close">
                <RoundButton
                    size={18}
                    description = { false }
                    icon = {IoClose}
                    name="Close"
                    onClick={ () => this.handleClose() }
                />
            </div>

            <h2>Buy Credits</h2>

            <form onSubmit={this.handlePay}>

                <div className="form-group">
                    <label className="label">Amount ($): </label>
                    <input 
                        type="text" 
                        name="amount" 
                        value={this.state.displayAmount} 
                        onChange={this.handleChange}
                        placeholder="Credits to topup"
                        className={`input ${this.state.errors.amount ? 'input-error' : ''}`}
                    />
                    {this.state.errors.amount && <span className="error-message">{this.state.errors.amount}</span>}
                </div>

                <button type="submit" className="button">Pay</button>

            </form>
        </dialog>
        );
    }
}
